import React from 'react';
import { CHECKOUT_URL } from '../data/content';
type Props = {
  label: string;
  note?: string;
  size?: 'md' | 'lg';
};
export function CtaButton({
  label,
  note,
  size = 'lg'
}: Props) {
  return <div className="w-full text-center" data-id="element-89" data-mp="hkf0immzain0">
      <a href={CHECKOUT_URL} className={`group inline-flex w-full max-w-xl items-center justify-center gap-2 rounded-2xl bg-brand-500 px-5 text-center font-sans font-extrabold uppercase tracking-wide text-white shadow-[0_10px_0_0_#1B5330] transition-[transform,background-color] duration-150 ease-out hover:bg-brand-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-700 active:translate-y-1 active:shadow-[0_5px_0_0_#1B5330] ${size === 'lg' ? 'min-h-[64px] py-4 text-[15px] leading-tight sm:text-lg' : 'min-h-[56px] py-3 text-[14px] leading-tight sm:text-base'}`} data-id="element-90" data-mp="hlgkjglz2fgv">
        <span aria-hidden="true" data-id="element-91" data-mp="15b186ct2m0wh">🟩</span>
        <span data-id="element-92" data-mp="35x5x1fzk8s30">{label}</span>
      </a>
      {note ? <p className="mx-auto mt-3 max-w-md text-[13px] font-medium leading-snug text-inksoft sm:text-sm" data-id="element-93" data-mp="35yqqf2a524za">
          {note}
        </p> : null}
    </div>;
}